<template>
  <div class="bottom">
      <div class="bottom-inner">
          <div class="contact-section">
              <div class="foot-col-title">联系我们</div>
              <div class="contact-info">
                  <div class="contact-item">全国服务咨询热线：</div>
                  <div class="contact-item highlight">010-21543930</div>
                  <div class="contact-item">邮箱：kefumail@aiytc.org.cn</div>
                  <div class="contact-item">地址：北京市昌平区石坊院21号13层1314</div>
              </div>
          </div>
          <div class="divider"></div>
          <div class="about-section">
              <div class="foot-col-title">关于我们</div>
              <div class="qrcode-wrap">
                  <img src="/qrcode.png" alt="二维码" class="qrcode-img">
                  <div class="qrcode-tip">扫一扫！关注更多新消息</div>
              </div>
          </div>
      </div>
      <div class="foot-copy">Copyright © 2025 青少年人工智能高水平创新人才培养工程版权所有 备案号：京ICP备2025132537号-2</div>
  </div>
</template>

<script>
  export default {
    data() {
      return{
        
      }
    },
    methods: {
    },
    created() {
     
    },
    mounted() {
      
    }
 }
</script>

<style  scoped>
.bottom {
    width: 100%;
    flex-shrink: 0;
    background: linear-gradient(135deg, #232B5C 0%, #2E2A6B 60%, #3B2E7E 100%);
    padding: 44px 60px 28px;
    box-sizing: border-box;
}
.bottom-inner {
    display: flex;
    justify-content: center;
    align-items: flex-start;
    gap: 48px;
    max-width: 700px;
    margin: 0 auto;
}
.contact-section {
    flex-shrink: 0;
}
.divider {
    width: 1px;
    background: rgba(255, 255, 255, 0.15);
    align-self: stretch;
    flex-shrink: 0;
}
.foot-col-title {
    font-size: 17px;
    font-weight: 700;
    color: #FFFFFF;
    letter-spacing: 2px;
    margin-bottom: 18px;
}
.contact-info {
    display: flex;
    flex-direction: column;
    gap: 8px;
}
.contact-item {
    font-size: 13px;
    color: rgba(255, 255, 255, 0.70);
    letter-spacing: 1px;
    line-height: 1.6;
}
.contact-item.highlight {
    font-size: 22px;
    font-weight: 700;
    color: #FFFFFF;
    letter-spacing: 2px;
    margin-top: 2px;
}
.about-section {
    flex-shrink: 0;
    text-align: center;
}
.qrcode-wrap {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 10px;
}
.qrcode-img {
    width: 110px;
    height: 110px;
    border-radius: 8px;
    background: #FFFFFF;
    padding: 6px;
    box-sizing: border-box;
}
.qrcode-tip {
    font-size: 12px;
    color: rgba(255, 255, 255, 0.50);
    letter-spacing: 1px;
}
.foot-copy {
    text-align: center;
    margin-top: 32px;
    padding-top: 20px;
    border-top: 1px solid rgba(255, 255, 255, 0.10);
    font-size: 12px;
    color: rgba(255, 255, 255, 0.35);
    letter-spacing: 1px;
    line-height: 1.8;
}
</style>
